import React from "react";
import { Button as BUTTON } from "antd";

const Button = ({
  icon,
  htmlType,
  title,
  color,
  border,
  borderRadius,
  onClick,
  loading,
  disabled = false,
  className = "w-31 xl:w-40",
  iconType = 'img'
}) => {
  return (
    <>
      <BUTTON
        htmlType={htmlType}
        className={className}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: `${color}`,
          padding: "8px 16px 8px",
          height: "54px",
          borderRadius: borderRadius || "12px",
          border: border ? `2px solid ${border}` : "",
          color: border ? { border } : "white",
        }}
        onClick={onClick}
        loading={loading}
        disabled={disabled}
      >
        {icon === 'img' ? <img src={icon} className="mr-0.4" alt="icon" /> : icon}
        {title}
      </BUTTON>
    </>
  );
};

export default Button;
